<template>
  <timeline-item
    type="Note"
    :title="title"
    :date="date"
    :pinned-by="pinnedBy"
    icon="text"
    color="is-notes"
  >
    <template v-slot:subtext>
      <div class="flex">
        <button-link
          class="mr-3"
          v-if="canEdit"
          @click="$refs.noteFormModal.open(note)"
        >
          edit
        </button-link>

        <button-link v-if="pinnedBy" @click="unpin" :loading="isPinLoading">unpin</button-link>
        <button-link v-else @click="pin" :loading="isPinLoading">pin</button-link>
      </div>
    </template>

    <hr class="my-50">
    <div class="note-message content mb-0" v-html="note.body"></div>

    <modal-container>
      <modal-crud-form
        ref="noteFormModal"
        title="Note"
        form-component="note-form"
        hide-delete-button
      ></modal-crud-form>
    </modal-container>
  </timeline-item>
</template>

<script>
import TimelineItem from "./TimelineItem";
import dates from "../../services/dates";
import api from "../../api";

export default {
  name: "TimelineNote",
  components: {
    TimelineItem
  },
  props: {
    note: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isPinLoading: false,
    }
  },
  computed: {
    canEdit() {
      const createdBy = this.note.createdBy;

      // If a note is not created by a user then it is always editable
      if (createdBy.class_name !== "App\\Models\\User") {
        return true;
      }

      // Notes created by a user can only be edited by that user
      return this.$store.state.activeUser.id === createdBy.id;
    },
    title() {
      const createdByName = this.note.createdBy.display_name;

      if (this.note.is_modified) {
        return (this.note.is_different_user)
          ? `${createdByName} (edited by ${this.note.updatedBy.display_name})`
          : `${createdByName} (edited)`;
      }

      return createdByName;
    },
    date() {
      return dates.formatAsDateTime(this.note.created_at);
    },
    pinnedBy() {
      if (!this.note.pinned_at) return null;

      return this.note.pinnedBy.display_name;
    }
  },
  methods: {
    pin() {
      this.isPinLoading = true
      api.notes.pin(this.note.id)
        .then(response => {
          this.$buefy.toast.open({
            message: 'Pinned note',
            type: 'is-success'
          });
        })
        .finally(() => this.isPinLoading = false)
    },
    unpin() {
      this.isPinLoading = true
      api.notes.unpin(this.note.id)
        .then(response => {
          this.$buefy.toast.open({
            message: 'Unpinned note',
            type: 'is-success'
          });
        })
        .finally(() => this.isPinLoading = false)
    }
  }
};
</script>

<style lang="scss" scoped>
  .note-message {
    max-width: 400px;
    word-wrap: break-word;
    overflow: hidden;
  }
</style>
